export default {
    accepted_by: "Kim tomonidan qabul qilindi",
    additional_costs: "Xarajatlar",
    additional_discount_correction: "Qo'shimcha chegirma uchun sozlash",
    additional_income: "Qo‘shimcha daromad",
    admin_statistics_future: "Kelgusi sanalar uchun yangi yozuvlar haqida administrator statistikasi",
    administrator_percent: "Administrator ulushi",
    administrator_sum: "Administrator miqdori",
    all_visits_of_current_branch_independent_of_status_including_cancelled: "Ushbu filialga barcha tashriflar, statusidan qat'i nazar, shu jumladan bekor qilingan",
    apply: "Qo‘llash",
    assistant_percent: "Yordamchi foiz",
    assistant_sum: "Yordamchi miqdori",
    average_cheque: "O‘rtacha chek",
    average_conversion_per_doctor_per_day: "Shifokorlar o‘rtasida o‘rtacha konversiya kundalik",
    average_conversion_per_doctor_per_period: "Shifokorlar o‘rtasida o‘rtacha konversiya davrida",
    average_qty_of_goods_in_cheque: "Kvitansiyadagi o'rtacha narsalar soni",
    balance_amount: "Depozitdan to‘landi",
    balance_return: "Depozitni qaytarish",
    became_permanent: "Doimiy bo‘ldilar",
    by: "Tomonidan",
    by_means: "To‘lov shakli bo‘yicha",
    by_services: "Xizmatlar bo‘yicha",
    calculated_from_calendar_visit_duration: "Kalendardagi yozuvning davomiyligidan hisoblangan",
    came_again: "Qayta kelganlar",
    came_among_patients: "Ulardan kelishdi",
    came_later_over_total_primary: "Birinchi marta tashrif buyuruvchilardan takroriy tashrif buyuruvchilar ulushi",
    cancel_date: "Bekor qilish sanasi",
    cancel_reason: "Bekor qilish sababi",
    cancelled_among_them: "Ulardan bekor qilindi",
    cancelled_visits: "Bekor qilingan tashriflar",
    cash_flow_statement: "Pul mablag‘lari harakati to‘g‘risidagi hisobot",
    cash_received_report_day_explanation: "Davr davomida olingan mablag'lar: tashriflar uchun to'lovlar (depozit, bonus, kafolat va boshqalar kabi to'lov turlaridan tashqari) va omonatni to'ldirish / yechib olishdan olingan mablag'lar",
    cashdesk_report: "Kassa hisoboti",
    conversion: "Konversiya",
    conversion_came_to_permanent: "Konversiya (keldi -> doimiy)",
    cos: "Tannarx",
    cost_of_attracting_primary_patient: "Birlamchi bemorni jalb qilish narxi",
    cost_of_materials: "Materiallar qiymati",
    cost_of_visits_for_selected_interval: "Tanlangan oraliqda yakunlangan tashriflar narxi",
    costs: "Xarajatlar",
    crm_leads_analytics: "CRM arizalari analitikasi",
    curator_id: "Kurator Id",
    curator_name: "Kurator ismi",
    curator_percent: "Kurator foizi",
    curator_sum: "Kurator summasi",
    daily_report: "Kun bo‘yicha hisobot",
    debt_payments: "Qarzlarni to‘lash",
    debt_writeoff: "Qarzlarni hisobdan chiqarish",
    debtor: "Qarzdor",
    debtors: "Qarzdorlar",
    debtors_statement: "Qarzdorlar to‘g‘risida hisobot",
    deleted_payments_registry: "O‘chirilgan to‘lovlar reyestri",
    deposit_movements: "Depozit harakatlari",
    deposit_reconciliation_report: "Depozitni muvofiqlashtirish to‘g‘risida akt",
    details_by_visits: "Tashriflar haqida tafsilotlar",
    did_not_came_again: "Qayta kelishdi",
    did_not_come_among_patients: "Ulardan kelmadi",
    doctor_load_percent: "Shifokor yuki %",
    doctor_name: "Shifokor",
    doctor_percent: "Shifokor foizi",
    doctor_salary: "Shifokor ish haqi",
    doctor_statistics: "Shifokorlar bo‘yicha statistika",
    doctor_sum: "Shifokor summasi",
    doctors_conversion: "Shifokorlar konversiyasi",
    doctors_load: "Shifokorlarni yuklash",
    duration: "Davomiylik",
    export_from: "Eksportdan",
    exports: "Eksportlar",
    f057: "057 shakl",
    first_visit_date: "Birinchi tashrif sanasi",
    first_visit_doctor: "Birinchi tashrif shifokori",
    full_name: "Ismi",
    general_percent: "Umumiy foiz",
    have_later_visits_independent_of_interval: "Tanlangan intervaldan qat'i nazar, kelajakdagi yozuvlar mavjud",
    have_later_visits_within_selected_interval: "Tanlangan oraliqda boshqa yozuvlar mavjud",
    have_no_later_visits_independent_of_interval: "Tanlangan oraliqdan qat'iy nazar boshqa yozuvlar yo'q",
    hidden_columns: "Yashirin ustunlar",
    hide_cancelled_visits: "Bekor qilingan tashriflarni yashirish",
    how_much_was_paid_for_visit_for_the_whole_time_independent_of_selected_period: "Tanlangan hisobot oralig'idan qat'i nazar, butun vaqt uchun tashrif uchun to'lov",
    in_progress: "Jarayonda",
    includes_both_discount_on_specific_services_and_general_discount: "Muayyan xizmatlarga chegirmalar va tashrif uchun umumiy chegirmani o'z ichiga oladi",
    including_adjustment_for_general_visit_discount: "Umumiy tashrif chegirmasi uchun tuzatishni o'z ichiga oladi",
    including_weighted_average_adjustment_for_general_visit_discount: "Tashrif uchun umumiy chegirma uchun o'rtacha vaznli tuzatishni o'z ichiga oladi",
    income_by_doctors: "Shifokorlar bo‘yicha daromad",
    income_by_services: "Xizmatlar bo‘yicha daromad",
    initiator: "Tashabbuschi",
    invoiced: "Hisob-kitob qilish",
    last_visit_date: "Oxirgi tashrif sanasi",
    last_visit_doctor: "Oxirgi tashrif shifokori",
    last_visit_recommendation: "Oxirgi tashrif tavsiyalari",
    list_of_patients_with_visits_in_this_branch_for_selected_interval: "Tanlangan interval uchun ushbu filialga tashrif buyurgan bemorlar ro'yxati",
    margins: "Yalpi daromad",
    materials_movement_analytics: "Materiallar harakati analitikasi",
    minutes_visit_was_opened_in_control_system: "Tashrif bayonnomalari “tashriflarning boshlanishi va tugashi” nazorat tizimida ochildi",
    next_visit_date: "Kelgusi tashrif sanasi",
    next_visit_doctor: "Kelgusi tashrif shifokori",
    number_of_patient_visits_for_given_interval: "Tanlangan interval uchun bemorga tashriflar soni",
    only_fiscal_cheques: "Faqat fiskal cheklar",
    only_fiscal_payments: "Faqat fiskal to‘lovlar",
    only_paid: "Faqat to‘langan",
    operation_type: "Operasiya turi",
    orthodontist: "Ortodont",
    orthopedist: "Ortoped",
    paid_for: "To'langan",
    paid_from_account: "Hisobdan to'langan",
    paid_invoices: "To‘langan hisoblar",
    paid_sum: "To'lov summasi",
    patient_deposits: "Bemorlarning depozitlari",
    patient_id: "Bemor Id",
    patient_name: "Bemor",
    patient_source: "Bemor manbai",
    patient_status: "Bemor holati",
    patients_conversion: "Bemorlar kon",
    payments_registry: "To'lov reestri",
    payments_within_interval_for_visits_happened_within_interval: "Tanlangan oraliq uchun to'lovlar miqdori faqat tanlangan intervalda sodir bo'lgan tashriflar uchun",
    payments_within_interval_for_visits_happened_within_interval_excluding_refunds: "Tanlangan oraliq uchun faqat tanlangan oraliqda yakunlangan tashriflar uchun toʻlovlar miqdori (toʻlov qaytarilmaydi)",
    pdf_report: "PDF hisobot",
    permanent_among_patients: "Ulardan doimiy bemorlar tashriflari",
    pl_statement: "Daromad va xarajatlar to‘g‘risidagi hisobot",
    plan_treatment_complexes: "Komplekslar",
    plan_treatments: "Davolanish rejasi",
    previous_visit_date: "Oldingi tashrif sanasi",
    price_before_discount: "Chegirmagacha bo‘lgan summa",
    primary: "Birinchi",
    primary_among_patients: "Ulardan birinchi bemorlar tashriflari",
    primary_marketing_expenses: "Birlamchi marketing xarajatlari",
    primary_records: "Birinchi - yozilgan",
    primary_records_came: "Birinchi - kelgan",
    primary_records_cancelled: "Birlamchi - bekor qilingan",
    primary_records_did_not_come: "Birinchi - kelmadi",
    primary_records_further: "Birinchi - keyingi yozilgan",
    primary_records_revenue: "Birinchi - daromad",
    product_name: "Mahsulot nomi",
    recorded_later: "Qayta yozib olingan",
    records: "Yozuvlar",
    records_count: "Tashriflar miqdori",
    refunds_within_interval: "Tanlangan oraliq uchun to'lovlarni qaytarish",
    repeated: "Takroriy",
    repeated_records: "Takroriy - yozilgan",
    repeated_records_came: "Takroriy - kelgan",
    repeated_records_cancelled: "Takrorlangan - bekor qilingan",
    repeated_records_did_not_come: "Takroriy - kelmadi",
    repeated_records_further: "Takroriy - keyingi yozilgan",
    repeated_records_revenue: "Takroriy - daromad",
    report_days_limit: "Hisobotlar muddati cheklovchi (kunlar)",
    report_is_too_heavy_confirm: "Hisobot sahifada ko'rish uchun juda katta, hisobotni excel fayliga eksport qilasizmi?",
    revenue: "Daromad",
    revenue_per_hour: "Bir soatlik daromad",
    revenues: "Daromad",
    revenues_report_day_explanation: "Tanlangan davr uchun tashriflar uchun to'lovlar, shuningdek, qo'shimcha daromadlar (buxgalteriya hisobidan) va tovarlarni sotishdan tushgan mablag'lar",
    salary_report: "Ish haqi hisoboti",
    saldo: "Saldo",
    sale_date: "Sotish sanasi",
    sales_funnel_applications: "Huni: arizalar va murojaatlar",
    sales_funnel_plans: "Huni: davolash rejalari",
    see_all: "Hamma ko'rish",
    see_only_yourself: "Faqat o'zingizni ko'ring",
    services_amount: "Xizmatlar miqdori",
    show_block_as_free_time: "Bloklarni bo'sh vaqt sifatida ko'rsatish",
    show_completed_visits: "Yakunlangan tashriflarni ko'rsatish",
    show_deleted: "O'chirilganlarni ko'rsatish",
    show_deleted_doctors: "Masofadagi shifokorlarni ko'rsating",
    show_only_new_patients: "Faqat yangi bemorlarni ko‘rsatish",
    source_of_patient_acquisition: "Bemorni jalb qilishning dastlabki manbai",
    source_of_visit_acquisition: "Yaratish manbasiga tashrif buyuring",
    source_type: "Manba turi",
    technic_percent: "Tenika foizi",
    technic_sum: "Texnika summasi",
    therapist: "Terapevt",
    total_acquiring_deductions: "Umumiy ekvayrinq chegirmalari",
    total_cost_of_services: "Xizmatlarning umumiy qiymati",
    total_materials_deductions: "Umumiy materiallar chegirmalari",
    total_patients: "Ro‘yxatga olingan bemorlar soni",
    total_payments: "Umumiy to‘lovlar",
    total_primary: "Umumiy birinchi",
    total_primary_patients_records: "Birlamchi bemorlarning umumiy yozuvlari",
    total_revenue: "Umumiy daromad",
    total_salary: "Umumiy ish haqi",
    total_technic_laboratory_deductions: "Umumiy texnik / laboratoriya chegirmalari",
    total_unique_primary_patients: "Umumiy noyob birlamchi bemorlar",
    total_with_deductions: "Umumiy chegirmalar bilan",
    unique_patients_recorded_during_selected_report_interval: "Tanlangan hisobot oralig'ida qayd etilgan noyob bemorlar soni",
    unique_patients_with_first_visit_for_interval: "Tanlangan oraliqda dastlabki tashrif bilan noyob bemorlar",
    unpaid_invoices: "To‘lanmagan hisob-kitoblar",
    updated_date: "Yangilangan sana",
    visit_id: "Yozuv Id",
    visit_price_including_all_discounts: "Barcha chegirmalarni o'z ichiga olgan tashrif narxi",
    visit_statistics: "Tashriflar statistikasi",
    visits_by_source: "Manbadan tashriflar",
    visits_cost_over_services_count: "Xizmatlar soniga tashriflar narxi",
    visits_detailed: "Tashriflar (tafsilotli)",
    visits_of_current_branch_which_has_services_or_has_status_other_than_not_come: "Xizmatlar belgilangan yoki “kelmadi” maqomidan boshqa holatga ega ushbu filialga tashriflar",
    visits_of_current_branch_which_have_services_or_have_status_came: "Xizmatlar yoki \"bemor keldi\" holati bilan tashriflar",
    visits_price_including_all_discounts: "Barcha chegirmalarni o'z ichiga olgan tashriflar narxi",
    where_came_from: "Qayerdan kelgan",
    who_cancelled: "Kim bekor qildi",
    who_changed_status: "Kim holatni o‘zgartirdi (to‘landi / keldi)",
    who_created: "Kim yaratgan",
    who_updated: "Kim yangilagan",
    with_patient: "Bemor bilan",
    worked_days: "Ishlangan kunlar",
    worked_hours: "Ishlangan soatlar",
    your_report_is_processing: "Hisobotingiz shakllanmoqda. U tayyor bo‘lganda sizga xabar beriladi."
}
